import { Environment } from '@environment/interfaces';
import { setEnvironmentVariables } from '@environment/utils/initialize-environment';
import { EnvironmentType } from '@environment/enums';

const environment: Environment = setEnvironmentVariables(process.env);

export default class Logger {

  constructor (private readonly loggerName: string) {
  }

  public log (logMessage: string) {
    this.performLogCall(console.log, logMessage)
  }

  public debug (logMessage: string) {
    this.performLogCall(console.debug, logMessage)
  }

  public info (logMessage: string) {
    this.performLogCall(console.info, logMessage)
  }

  public warn (logMessage: string) {
    this.performLogCall(console.warn, logMessage)
  }

  public error (logMessage: string) {
    this.performLogCall(console.error, logMessage)
  }

  private performLogCall (logFunction: Function, logMessage: string) {
    if (environment.type === EnvironmentType.Development) {
      logFunction(`${this.loggerName} - ${logMessage}`)
    }
  }
}
